if (!customElements.get('cart-complementary-products')) {
  class CartComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.cartProductIds = (this.dataset.cartProductIds || '')
        .split(',')
        .filter(Boolean)
        .map(Number);

      this.content = this.querySelector('.cart-complementary__content');
      this.track = this.querySelector('.cart-complementary__track');
      this.counter = this.querySelector('.cart-complementary__counter');

      if (!this.productId || !this.content || !this.track) return;

      this.loadRecommendations();
    }

    async loadRecommendations() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const url =
          `${root}recommendations/products.json` +
          `?product_id=${this.productId}&limit=6&intent=complementary`;

        const response = await fetch(url);

        if (!response.ok) return;

        const data = await response.json();

        const products = (data.products || [])
          .filter((product) => product.available)
          .filter(
            (product) =>
              !this.cartProductIds.includes(Number(product.id))
          )
          .slice(0, 3);

        if (!products.length) return;

        this.track.innerHTML = products
          .map((product) => this.createCard(product))
          .join('');

        this.counter.textContent = `1 / ${products.length}`;
        this.content.hidden = false;

        this.activateButtons();
        this.activateCounter(products.length);
      } catch (error) {
        console.error('Error al cargar productos complementarios:', error);
      }
    }

    createCard(product) {
      const variants = (product.variants || []).filter(
        (variant) => variant.available
      );

      const image =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image?.url || product.images?.[0] || '';

      const url = product.url || '#';
      const price = this.formatMoney(product.price);

      const action =
        variants.length === 1
          ? `
            <button
              type="button"
              class="cart-complementary__button"
              data-variant-id="${variants[0].id}"
            >
              Agregar
            </button>
          `
          : `
            <a class="cart-complementary__button" href="${url}">
              Ver opciones
            </a>
          `;

      return `
        <article class="cart-complementary__card" role="listitem">
          <a class="cart-complementary__image-link" href="${url}">
            ${
              image
                ? `
                  <img
                    class="cart-complementary__image"
                    src="${image}"
                    alt="${this.escapeHtml(product.title)}"
                    width="80"
                    height="80"
                    loading="lazy"
                  >
                `
                : ''
            }
          </a>

          <div class="cart-complementary__details">
            <a class="cart-complementary__product-title" href="${url}">
              ${this.escapeHtml(product.title)}
            </a>

            <span class="cart-complementary__price">
              ${price}
            </span>
          </div>

          ${action}
        </article>
      `;
    }

    activateButtons() {
      this.querySelectorAll('[data-variant-id]').forEach((button) => {
        button.addEventListener('click', () => this.addToCart(button));
      });
    }

    activateCounter(total) {
      this.track.addEventListener('scroll', () => {
        const card = this.track.querySelector(
          '.cart-complementary__card'
        );

        if (!card) return;

        const current = Math.min(
          total,
          Math.max(
            1,
            Math.round(this.track.scrollLeft / card.offsetWidth) + 1
          )
        );

        this.counter.textContent = `${current} / ${total}`;
      });
    }

    async addToCart(button) {
      const variantId = Number(button.dataset.variantId);
      const drawer = document.querySelector('cart-drawer');
      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Agregando…';

      try {
        const root = window.Shopify?.routes?.root || '/';

        const sections = drawer?.getSectionsToRender
          ? drawer
              .getSectionsToRender()
              .map((section) => section.id)
          : [];

        const response = await fetch(
          window.routes?.cart_add_url || `${root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              sections,
              sections_url: window.location.pathname
            })
          }
        );

        const state = await response.json();

        if (!response.ok) {
          throw new Error(
            state.description || 'No se pudo agregar el producto'
          );
        }

        if (drawer?.renderContents && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error(error);

        button.disabled = false;
        button.textContent = 'Intenta otra vez';

        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    }

    escapeHtml(value) {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    }
  }

  customElements.define(
    'cart-complementary-products',
    CartComplementaryProducts
  );
}
(() => {
  const INTERVALO = 4000;

  function activarCarrusel(carrusel) {
    if (carrusel.dataset.autoplayActivo === 'true') return;
    carrusel.dataset.autoplayActivo = 'true';

    let indice = 0;
    let temporizador;

    const obtenerPista = () =>
      carrusel.querySelector('.cart-complementary__track');

    const obtenerTarjetas = () => {
      const pista = obtenerPista();
      return pista ? Array.from(pista.children) : [];
    };

    const detener = () => {
      clearInterval(temporizador);
    };

    const iniciar = () => {
      detener();

      temporizador = setInterval(() => {
        const pista = obtenerPista();
        const tarjetas = obtenerTarjetas();

        if (!pista || tarjetas.length < 2 || document.hidden) return;

        indice = (indice + 1) % tarjetas.length;
        const tarjeta = tarjetas[indice];

        pista.scrollTo({
          left: tarjeta.offsetLeft - pista.offsetLeft,
          behavior: 'smooth'
        });
      }, INTERVALO);
    };

    carrusel.addEventListener('mouseenter', detener);
    carrusel.addEventListener('mouseleave', iniciar);
    carrusel.addEventListener('focusin', detener);
    carrusel.addEventListener('focusout', iniciar);
    carrusel.addEventListener('touchstart', detener, { passive: true });
    carrusel.addEventListener('touchend', iniciar, { passive: true });

    iniciar();
  }

  function buscarCarruseles() {
    document
      .querySelectorAll('cart-complementary-products')
      .forEach(activarCarrusel);
  }

  buscarCarruseles();

  new MutationObserver(buscarCarruseles).observe(document.body, {
    childList: true,
    subtree: true
  });
})();